import template from './ko-render-field-time.html';

class TimeInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.hide_labels = ko.observable(params.hide_labels);
		this.$input = params.$input;

		console.log('params', params);

		console.log('input:', this.$input());

		if (params.type == 'text_readonly')
			this.readonly(true);
		else
			this.readonly(false);
	}
}

export default {
	name: 'ko-render-field-time',
	viewModel: TimeInputComponentVM,
	module_type: 'ko',
	template: template
}